export const API_GET_REFERRALS_BY_USER_ID_PENDING = 'API_GET_REFERRALS_BY_USER_ID_PENDING';
export const API_GET_REFERRALS_BY_USER_ID_SUCCESS = 'API_GET_REFERRALS_BY_USER_ID_SUCCESS';
export const API_GET_REFERRALS_BY_USER_ID_FAILURE = 'API_GET_REFERRALS_BY_USER_ID_FAILURE';
export const API_ADD_APP_ID_TO_REFERRAL_PENDING = 'API_ADD_APP_ID_TO_REFERRAL_PENDING';
export const API_ADD_APP_ID_TO_REFERRAL_SUCCESS = 'API_ADD_APP_ID_TO_REFERRAL_SUCCESS';
export const API_ADD_APP_ID_TO_REFERRAL_FAILURE = 'API_ADD_APP_ID_TO_REFERRAL_FAILURE';
export const API_CREATE_REFERRAL_PENDING = 'API_CREATE_REFERRAL_PENDING';
export const API_CREATE_REFERRAL_SUCCESS = 'API_CREATE_REFERRAL_SUCCESS';
export const API_CREATE_REFERRAL_FAILURE = 'API_CREATE_REFERRAL_FAILURE';
export const API_GET_USER_REF_BY_PROMO_ID_PENDING = 'API_GET_USER_REF_BY_PROMO_ID_PENDING';
export const API_GET_USER_REF_BY_PROMO_ID_SUCCESS = 'API_GET_USER_REF_BY_PROMO_ID_SUCCESS';
export const API_GET_USER_REF_BY_PROMO_ID_FAILURE = 'API_GET_USER_REF_BY_PROMO_ID_FAILURE';
export const GET_SHORT_URL_REQUEST = 'GET_SHORT_URL_REQUEST';
export const GET_SHORT_URL_SUCCESS = 'GET_SHORT_URL_SUCCESS';
export const GET_SHORT_URL_FAILURE = 'GET_SHORT_URL_FAILURE';
export const RESET_SHORT_URL_DATA = 'RESET_SHORT_URL_DATA';
export const REFERRAL_BY_APPT_ID_PENDING = 'REFERRAL_BY_APPT_ID_PENDING';
export const REFERRAL_BY_APPT_ID_SUCCESS = 'REFERRAL_BY_APPT_ID_SUCCESS';
export const REFERRAL_BY_APPT_ID_FAILURE = 'REFERRAL_BY_APPT_ID_FAILURE';
